enum ChildcareTenancyEnum {
  Single = 'Single',
  Multi = 'Multi',
}

export default ChildcareTenancyEnum;
